import React from "react";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import useAuthStore from "../../stores/useAuthStore";
import { BASE_LOGIN_REDIRECT_URL } from "../../constants/api.constants";

const SwitchedUserNotice = () => {
  const switchedUser = useAuthStore((state) => state.switchedUser);

  return (
    <Modal isOpen={switchedUser} backdrop="static" keyboard={false} centered>
      <ModalBody>
        <FormattedMessage id="SignedInAsAnotherUserInAnotherTab" />
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => window.location.replace(`${BASE_LOGIN_REDIRECT_URL}/`)}
        >
          <FormattedMessage id="LinkStatus.ToStartPage" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SwitchedUserNotice;
